import {computed, WritableComputedRef} from "vue";
import {useVModel} from "@vueuse/core/index";
import {useField, useValidateField} from "vee-validate";
import type {ComputedRef} from "vue";
import {TRuleSet} from "@/components/generics/DynamicForm/composable/useRuleSet";
import {TRule} from "@/components/generics/types/TRule";

interface IFieldModelOption {
    name?: string
    nameIsProp?: boolean
    useVModel?: boolean
    validateOnInput?: boolean,
    validateOnMount?: boolean,
    initialValue?: any,
    rules?: TRule | TRuleSet
}

export const useFieldModel = (props, modelKey: string, emit, options?: IFieldModelOption) => {
    if (options === undefined) {
        options = {}
    }
    let name: WritableComputedRef<string> | ComputedRef<string> = computed({
        get(): string {
            if (options === undefined) {
                options = {}
            }
            if (!options.name) {
                options.name = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
            }
            return options.name;
        },
        set(value: string) {
            if (options === undefined) {
                options = {}
            }
            options.name = value
        }
    })

    if (typeof options.name === "string") {
        if (typeof options.nameIsProp === "boolean" && options.nameIsProp) {
            name = useVModel(props, 'name', emit);
        }
    }

    const fieldOpts = {}
    if (options.validateOnMount){
        fieldOpts['validateOnMount'] = true
    }
    if (options.validateOnInput){
        fieldOpts['validateOnValueUpdate'] = true
    }
    if (options.useVModel) {
        fieldOpts['syncVModel'] = true
        fieldOpts['initialValue'] = props[modelKey]
    }
    if (options.initialValue) {
        fieldOpts['initialValue'] = options.initialValue
    }


    const {value, errorMessage, errors} = useField(name, options.rules, fieldOpts);

    const validate = useValidateField(name)
    return {
        value,
        errorMessage,
        errors,
        validate
    }
}